import { render, staticRenderFns } from "./closureSearch.vue?vue&type=template&id=b8233b82&scoped=true"
import script from "./closureSearch.vue?vue&type=script&lang=js"
export * from "./closureSearch.vue?vue&type=script&lang=js"
import style0 from "./closureSearch.vue?vue&type=style&index=0&id=b8233b82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8233b82",
  null
  
)

export default component.exports